import { createApp } from 'vue'
import App from './App.vue'
import VueMatomo from 'vue-matomo';

let app = createApp(App)
app.use(VueMatomo, {
    host: "https://cloud2.ynt-studio.art/matomo/",
    siteId: 1,
    trackerFileName: 'matomo',
    // router: router,
    enableLinkTracking: true,
    requireConsent: false,
    trackInitialView: true,
    disableCookies: false,
    enableHeartBeatTimer: true,
    heartBeatTimerInterval: 15,
    debug: false,
    userId: undefined,
    cookieDomain: undefined,
    domains: undefined,
    preInitActions: []
});
app.mount('#app');